import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 pt-24" data-testid="payment-cancel-page">
      <div className="max-w-md w-full backdrop-blur-xl bg-[#101C3E]/70 border border-[#d4af37]/30 p-10 text-center">
        <XCircle size={40} className="text-slate-400 mx-auto mb-6" />
        <h1 className="font-display text-3xl font-light text-slate-50">
          Payment <span className="italic text-[#d4af37]">cancelled.</span>
        </h1>
        <p className="text-slate-400 text-sm mt-4 leading-relaxed">
          No amount was charged. Your booking request is still with us — you can pay the advance
          anytime from your My Trips page, or simply confirm on WhatsApp.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
          <Link
            to="/account"
            data-testid="cancel-my-trips-link"
            className="border border-[#d4af37] text-[#d4af37] px-8 py-3 text-xs tracking-[0.15em] uppercase hover:bg-[#d4af37] hover:text-[#0A1128] transition-colors"
          >
            My Trips
          </Link>
          <Link
            to="/"
            data-testid="cancel-home-link"
            className="border border-slate-50/30 text-slate-300 px-8 py-3 text-xs tracking-[0.15em] uppercase hover:border-[#d4af37] hover:text-[#d4af37] transition-colors"
          >
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}
